module.exports = __webpack_public_path__ + "static/img/16.4688667.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/16.png
// module id = JinL
// module chunks = 0